<div class="row noDatafound">
  <div class="no-items">
    <div *ngIf="screen === 'EMPTY'; else checkOtherScreens">
      <ng-icon name="tablerInbox"></ng-icon>
    </div>
    <ng-template #checkOtherScreens>
      <div *ngIf="screen === 'CONNECTION' || screen === 'BUSINESS' || screen === 'TEAM'; else searchOrFallback">
        <ng-icon name="tablerUsersGroup"></ng-icon>
      </div>
    </ng-template>
    <div *ngFor="let item of title" style="padding-left:5px;">
      <div for="" *ngIf="setBold(item)"><b>{{removeB(item)}}</b></div>
      <div class="wordbreak" for="" *ngIf="!setBold(item)">{{item}}</div>
    </div>
    <div class="col-sm-4" *ngIf="buttonName&&buttonShow">
      <button [disabled]="isButtonDisabled" class="btn btn-primary"  (click)="open()">
        <span class="mr-5"> </span> {{buttonName}}
      </button>
    </div>
  </div>
</div>

<!--
  SEARCH branch: explicitly rendered when callers pass screen="SEARCH"
  (e.g., team-members / community-members "no results" empty state).
  Anything that isn't EMPTY / CONNECTION / BUSINESS / TEAM also falls
  through here, preserving prior behaviour for unspecified screen
  values.
-->
<ng-template #searchOrFallback>
  <ng-icon name="tablerZoomQuestion"></ng-icon>
</ng-template>